import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { PhillipMark } from "@/components/Logo";
import { SITE } from "@/constants/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-ink text-cream"
        >
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12">
                <div className="flex flex-col justify-between gap-12 md:flex-row">
                    <div className="max-w-sm">
                        <div className="flex items-center gap-3">
                            <PhillipMark className="h-10 w-10 text-gold" />
                            <span className="font-serif text-3xl font-medium">
                                Phillip
                                <span className="ml-2 align-middle font-mono text-[10px] uppercase tracking-[0.25em] text-cream/60">
                                    CPA
                                </span>
                            </span>
                        </div>
                        <p className="mt-5 text-sm leading-relaxed text-cream/70">
                            A new boutique CPA practice bringing clarity,
                            warmth, and precision to your books.
                        </p>
                    </div>

                    <div className="flex gap-16 sm:gap-24">
                        <div className="flex flex-col gap-3">
                            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/50">
                                Explore
                            </p>
                            {[
                                ["Home", "/"],
                                ["Services", "/services"],
                                ["About", "/about"],
                                ["Contact", "/contact"],
                            ].map(([label, path]) => (
                                <Link
                                    key={path}
                                    to={path}
                                    data-testid={`footer-link-${label.toLowerCase()}`}
                                    className="link-underline w-fit text-sm text-cream/80 hover:text-cream"
                                >
                                    {label}
                                </Link>
                            ))}
                        </div>
                        <div className="flex flex-col gap-3">
                            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/50">
                                Reach us
                            </p>
                            <a
                                href={SITE.phoneHref}
                                data-testid="footer-link-phone"
                                className="flex items-center gap-2 text-sm text-cream/80 hover:text-cream"
                            >
                                <Phone className="h-3.5 w-3.5" />
                                {SITE.phoneDisplay}
                            </a>
                            <a
                                href={`mailto:${SITE.email}`}
                                data-testid="footer-link-email"
                                className="flex items-center gap-2 text-sm text-cream/80 hover:text-cream"
                            >
                                <Mail className="h-3.5 w-3.5" />
                                {SITE.email}
                            </a>
                            <p className="text-sm text-cream/50">
                                {SITE.location}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-16 flex flex-col justify-between gap-3 border-t border-cream/10 pt-6 text-xs text-cream/50 sm:flex-row">
                    <p data-testid="footer-copyright">
                        © {new Date().getFullYear()} {SITE.name}. All rights
                        reserved.
                    </p>
                    <p>Fresh books, warm advice.</p>
                </div>
            </div>
        </footer>
    );
}
